<span
  [class]="class + ' ' + negativeColor"
  >{{ value | numberFormat : format }}</span
>
